import isNil from 'lodash/isNil';
import {useId} from 'react';
import {twMerge} from '../../../common/twMerge';
import {Text} from '../../atoms/Text/Text';
import {FormGroupV2Props} from './FormGroupV2Props.interface';

export function FormGroupV2({
  isMobile,
  status = 'normal',
  label,
  children,
  subLabel,
  currentValue,
  maxValue,
  additionalInfo,
  required,
  className,
}: FormGroupV2Props) {
  const id = useId();
  return (
    <div
      className={twMerge(
        'flex',
        isMobile ? 'flex-col space-y-10pxr' : 'flex-row space-x-12pxr',
        className
      )}
    >
      {label && (
        <label
          htmlFor={id}
          className={twMerge('flex items-center', !isMobile && 'h-48pxr')}
        >
          <Text
            className={twMerge(
              'text-theme-solid-100 font-small2-bold',
              isMobile ? 'w-full' : 'w-140pxr'
            )}
          >
            {label}{' '}
            {required && <span className="text-static-point-red">*</span>}
          </Text>
        </label>
      )}
      <div className="flex flex-col w-full min-w-0">
        {children(id)}
        {(subLabel || (!isNil(currentValue) && !isNil(maxValue))) && (
          <div className="flex mt-4pxr px-8pxr justify-between">
            {subLabel && (
              <Text
                className={twMerge(
                  'font-small2 text-theme-solid-40 whitespace-pre-wrap',
                  status === 'error' && 'text-static-point-red'
                )}
              >
                {subLabel}
              </Text>
            )}
            <div />
            {!isNil(currentValue) && !isNil(maxValue) && (
              <Text className="font-small2 text-theme-solid-40">
                <span className="font-small2-bold text-theme-solid-100">
                  {currentValue}
                </span>
                <span className="mx-2pxr">/</span>
                <span>{maxValue}</span>
              </Text>
            )}
          </div>
        )}
        {additionalInfo && <div className="mt-8pxr">{additionalInfo}</div>}
      </div>
    </div>
  );
}
